import { useMutation, useQueryClient } from "@tanstack/react-query";
import { datosGeneralesApi } from "@/features/datos-generales/services/datos-generales.api";
import type { DatosGeneralesInput } from "@/features/datos-generales/types";
import { qk } from "@/lib/query-keys";
import type { SolicitudDetalle } from "@/lib/types";
import { toastError, toastExito } from "@/lib/toast";
import { extractApiMessage } from "@/shared/api/extract-message";

/**
 * Mutation para capturar los datos generales · al éxito hidrata el cache
 * de la solicitud (el backend devolvió el agregado actualizado con
 * estado `SeleccionandoProveedor`) y notifica.
 *
 * La navegación a `/proveedor` queda a cargo del componente (vía
 * `onSuccess` opcional) · este hook no acopla routing.
 */
export function useCapturarDatosGenerales(
  solicitudId: string,
  options?: { onSuccess?: (solicitud: SolicitudDetalle) => void }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: DatosGeneralesInput) =>
      datosGeneralesApi.capturar(solicitudId, input),
    onSuccess: (solicitud) => {
      qc.setQueryData(qk.solicitud(solicitudId), solicitud);
      toastExito({ title: "Datos guardados", message: "Continúa con la selección del proveedor." });
      options?.onSuccess?.(solicitud);
    },
    onError: (e) => toastError({ title: "Error", message: extractApiMessage(e, "Error guardando datos generales") }),
  });
}
